import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type components } from 'src/api/playerPayback/api'

export const useGetAllJJBadges = (): UseQueryResult<
  Array<components['schemas']['BadgeRewardDTO']>
> => {
  const get = useTypedApiClient({
    path: '/admin/badgerewards/jjBadges',
    method: 'get',
  })
  return useQuery({
    queryKey: ['/admin/badgerewards/jjBadges'],
    queryFn: async () => {
      const { data } = await get({})
      return data
    },
  })
}
